<se-fe-side-panel [ngClass]="sidePanelClass"
  #sidePanel
  [seFeDataLoaded]="!!profile"
  [(seFeDataVisible)]="showSidePanel"
  (seFeClose)="close()">
  <div *ngIf="menuOptions" seFeSidePanelActions>
    <se-fe-icon-button [seFeMenuTrigger]="moreMenu">
      <se-fe-icon
        seFeDataName="more"
        seFeDataSize="700"
        seFeDataAriaLabel="more">
      </se-fe-icon>
    </se-fe-icon-button>
    <se-fe-menu #moreMenu [seFeDataOptions]="menuOptions"></se-fe-menu>
  </div>
  <se-fe-header seFeSidePanelHeader *ngIf="profile"
    [seFeDataTitle]="!headerLink && persona?.full_name"
    [seFeDataSubtitle]="profileSubtitle">
    <se-fe-avatar *ngIf="editableAvatar"
      seFeHeaderVisual
      seFeDataType="persona"
      [seFeDataIdentity]="persona?.full_name"
      [seFeDataImgUrl]="profileImageUrl"
      (seFeClick)="onAvatarClick()">
    </se-fe-avatar>
    <se-fe-avatar *ngIf="!editableAvatar"
      seFeHeaderVisual
      seFeDataType="persona"
      [seFeDataIdentity]="persona?.full_name"
      [seFeDataImgUrl]="profileImageUrl">
    </se-fe-avatar>
    <a seFeHeaderTitle *ngIf="headerLink" seFeLink="low" [href]="headerLink">{{ persona?.full_name }}</a>
  </se-fe-header>
  <div seFeSidePanelContent>
    <ng-content select="[profileSidePanelContent]"></ng-content>
  </div>
</se-fe-side-panel>
